module.exports = __webpack_public_path__ + "img/dhfesta_logo_eng3_2024.6183a674.png";